import { useQuery } from "react-query";
import { getNumberOfUnits } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useNumberOfUnits = () => {
  const { data, isLoading, refetch } = useQuery(
    "getNumberOfUnits",
    getNumberOfUnits,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
